import axios from "axios";
import { API_URL } from "../../constants";

export default {
  getAllProductData: (uuid) => {
    return axios.get(`${API_URL.PRODUCT_MAPPING}/${uuid}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  updateProductData: (data, uuid) => {
    return axios.put(`${API_URL.PRODUCT_MAPPING}/${uuid}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
};
